import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Nav } from "react-bootstrap";

import EncryptData from "./EncryptData/EncryptData";
import EncryptView from "./Encrypt/EncryptView";
import ProtectView from "./Protect/Protect";

class Encryption extends Component {
  constructor() {
    super();
    this.state = {
      type: "encrypt",
      errors: {},
    };
  }

  componentDidMount() {}

  render() {
    return (
      <div className="container" style={{ marginTop: "50px" }}>
        <Nav fill variant="tabs" defaultActiveKey="encrypt">
          <Nav.Item
            onClick={() => {
              this.setState({ type: "protect" });
            }}
          >
            <Nav.Link eventKey="protect">
              Шифрование данных с защитой на ключ и подписью отправителя
            </Nav.Link>
          </Nav.Item>
          <Nav.Item
            onClick={() => {
              this.setState({ type: "encrypt" });
            }}
          >
            <Nav.Link eventKey="encrypt">Шифрование данных</Nav.Link>
          </Nav.Item>
          <Nav.Item
            onClick={() => {
              this.setState({ type: "encrypt_data" });
            }}
          >
            <Nav.Link eventKey="encrypt_data">
              Шифрование данных с защитой на ключ
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <div className="sm-4">
          {this.state.type === "encrypt_data" ? <EncryptData /> : null}
          {this.state.type === "encrypt" ? <EncryptView /> : null}
          {this.state.type === "protect" ? <ProtectView /> : null}
        </div>
      </div>
    );
  }
}
export default connect()(withRouter(Encryption));
